export default __webpack_public_path__ + "static/realWorldImg3-eded87606ae6e9f47c38eb66a85c2de2.webp";